/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import 'react-app-polyfill/stable';

import './style/custom.scss';
import './js/util/startup';
import React from 'react';
import {createRoot} from 'react-dom/client';
import {AppContextProvider} from "./js/components/misc/appContext";
import {RouteElements} from "./js/routes";
import {createBrowserRouter, createRoutesFromElements, RouterProvider} from 'react-router-dom';
import {getSetting} from '@dvrd/dvr-controls';


const router = createBrowserRouter(createRoutesFromElements(RouteElements), {basename: getSetting('appBaseUrl')});

const rootElement = document.getElementById('content');
if (rootElement) {
    createRoot(rootElement).render(
        <AppContextProvider>
            <RouterProvider router={router}/>
        </AppContextProvider>
    );
}